/*
 * File: c:\Users\j.mazat\Desktop\Autobuy\AutobuyBackOffice\src\Content\SectionHeader\TitlePage.tsx
 * Project: c:\Users\j.mazat\Desktop\Autobuy\AutobuyBackOffice
 * Created Date: Friday June 23rd 2023
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Friday, 30th June 2023 12:29:19
 * Modified By: Simon (s.gourlet@autobuy.fr>)
 * -----
 * Copyright (c) 2023 Autobuy SAS
 * -----
 */

import BackArrow from "Content/BackArrow/BackArrow";
import Styles from "Content/HeadingPage/TitlePage/TitlePage.module.css";

type SectionHeaderProps = {
    title: string;
    subTitle?: string;
    backLink?: string;
    action?: JSX.Element;
}

function TitlePage(props: SectionHeaderProps) {
    return (
        <div className={`${Styles.titlePageHolder}`}>
            <div className={`${Styles.backArrow}`}>
                <BackArrow backLink={props.backLink} />
            </div>
            <div className={`${Styles.titles}`}>
                <h1> {props.title} </h1>
                {
                    props.subTitle ? <h3> {props.subTitle} </h3> : null
                }
            </div>
            {
                props.action ? props.action
                : null
            }
        </div>
    )
}

export default TitlePage;
